import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { IAppStore } from '../HomeWorkouts';
import {
  closeOptOutLeaderboardModal as closeOptOutLeaderboardModalAction,
} from '../Tracking/actions';
import { BaseModal } from '../ui';
import { UserDataConsumer } from '../utils';
import { defaultScale } from '../utils/scaling';
import { LeaderboardOptOut } from './LeaderboardOptOutScreen';

interface IProps {
  isLeaderboardOptOutModalVisible: boolean;
  closeOptOutLeaderboardModal: () => void;
  navigation: any;
  isOpenedFromDashboard: boolean;
}

const LeaderboardOptOutModalScreen: FunctionComponent<IProps> = (
  {
    isLeaderboardOptOutModalVisible, closeOptOutLeaderboardModal, navigation, isOpenedFromDashboard,
  },
) => {
  if (!isLeaderboardOptOutModalVisible) {
    return <></>;
  }

  return (
    <BaseModal
      isModalVisible={isLeaderboardOptOutModalVisible}
      hideCloseButton={false}
      useSafeAreaView
      showHeader={false}
      bodyStyle={styles.modalBody}
      closeModal={closeOptOutLeaderboardModal}
      containerStyle={styles.modalContainer}
    >
      <LeaderboardOptOut navigation={navigation} />
    </BaseModal>
  );
};

const mapStateToProps = (state: IAppStore) => ({
  isLeaderboardOptOutModalVisible: state.tracking.view.isLeaderboardOptOutModalVisible,
});

const mapDispatchToProps = (dispatch) => ({
  closeOptOutLeaderboardModal: () => dispatch(closeOptOutLeaderboardModalAction()),
});

const styles = StyleSheet.create({
  modalContainer: {
    height: '100vh',
  },
  modalBody: {
    padding: 0,
    paddingTop: defaultScale(12),
    paddingHorizontal: defaultScale(20),
  },
});

export const LeaderboardOptOutModal = translate(
  ['dashboard', 'tracking'],
  { wait: true },
)(UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(LeaderboardOptOutModalScreen)));
